import { createContext, useContext, useState } from "react";
// import { createNewAuthor, deleteAuthor, updateAuthor } from "../../../lib/firebase/author/write";
// import { getAuthor } from "../../../lib/firebase/author/read";
import { createNewAuthor, deleteAuthor, updateAuthor } from "../../../../lib/firebase/author/write";
import { getAuthor } from "../../../../lib/firebase/author/read";
import { useNavigate } from "react-router-dom";

const AuthorFormContext = createContext();

export function useAuthorForm() {
    return useContext(AuthorFormContext);
}

export default function AuthorFormContextProvider({ children }) {
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isDone, setIsDone] = useState(false);
    const [image, setImage] = useState(null);

    // Handle Input Data Changes
    const handleData = (key, value) => {
        setIsDone(false);
        setData((prevData) => ({
            ...prevData,
            [key]: value,
        }));
    };

    // Create a New Author
    const handleCreate = async () => {
        setError(null);
        setIsLoading(true);
        setIsDone(false);
        try {
            await createNewAuthor({ data, image });
            setIsDone(true);
            navigate("/admin/authors"); // Redirect to Authors List
        } catch (error) {
            setError(error?.message);
        }
        setIsLoading(false);
    };

    // Update an Existing Author
    const handleUpdate = async (id) => {
        setError(null);
        setIsLoading(true);
        setIsDone(false);
        try {
            console.log("Updating Author:", data);
            await updateAuthor({ id, data, image });
            setIsDone(true);
            navigate("/admin/authors");
        } catch (error) {
            setError(error?.message);
        }
        setIsLoading(false);
    };

    // Delete an Author
    const handleDelete = async (id) => {
        setError(null);
        setIsLoading(true);
        setIsDone(false);
        try {
            await deleteAuthor(id);
            setIsDone(true);
            navigate("/admin/authors");
        } catch (error) {
            setError(error?.message);
        }
        setIsLoading(false);
    };

    // Fetch Author Data for Editing
    const fetchData = async (id) => {
        setError(null);
        setIsLoading(true);
        setIsDone(false);
        try {
            const res = await getAuthor(id);
            if (res.exists()) {
                console.log("Fetched Author Data:", res.data());
                setData({ ...res.data(), id }); // Include ID in the state
            } else {
                throw new Error(`No Author found with ID ${id}`);
            }
        } catch (error) {
            setError(error?.message);
        }
        setIsLoading(false);
    };

    return (
        <AuthorFormContext.Provider
            value={{
                data,
                isLoading,
                error,
                isDone,
                handleData,
                handleCreate,
                handleUpdate,
                handleDelete,
                image,
                setImage,
                fetchData,
            }}
        >
            {children}
        </AuthorFormContext.Provider>
    );
}
